import { types } from 'mobx-state-tree'
import { DictionaryModel } from '../common'

export const MaterialCountryMarksModel = types.model('MaterialCountryMarksModel', {
  id: types.number,
  countryId: types.number,
  material: types.maybeNull(DictionaryModel),
  importMeasurementUnits: types.array(types.number),
})
